import tippy from 'tippy.js/esm'

const SELECTORS = Selectors({
  imageMap: '[data-image-map]'
})

const props = {
  $elements: document.querySelectorAll(SELECTORS.imageMap)
}

const fn = {
  init: () => {
    props.$elements.forEach($el => {
      const $tooltips = $el.querySelectorAll('.image-map-area')

      $tooltips.forEach($tooltip => {
        tippy($tooltip, {
          arrow: true,
          content: $tooltip.dataset.content,
          touch: false,
          distance: 0
        })
      })
    })
  }
}

export default {
  can: () => props.$elements.length,
  run: fn.init
}
